export default __webpack_public_path__ + "static/media/orange_arrow_right.dd4445e2.svg";